export function init() {
  console.log("Educraft boilerplate JS loaded.");
}
